module.exports = __webpack_public_path__ + "media/assets/images/blog/AWS_Elastic_Load_Balancer-small-12b49ba7b46ef478d8584844ee09b25d.png";